export default "__VITE_ASSET__CAJXByPe__"